function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.434 17.896a3.539 3.539 0 01-3.538 3.538H6.104a3.539 3.539 0 01-3.538-3.538V6.104a3.539 3.539 0 013.538-3.538h11.792a3.539 3.539 0 013.538 3.538zm-3.17-2.444a13.816 13.816 0 00-2.21-1.327c-.234-.135-.516-.405-.799-.405-.54 0-1.339 1.609-1.818 1.609a1.978 1.978 0 01-.774-.344 8.995 8.995 0 01-3.648-3.648 1.978 1.978 0 01-.344-.774c0-.48 1.61-1.278 1.61-1.818 0-.283-.27-.565-.406-.798a13.816 13.816 0 00-1.327-2.211.54.54 0 00-.196-.025 4.314 4.314 0 00-1.24.27A3.58 3.58 0 005.71 8.745a6.775 6.775 0 00.614 2.334 12.466 12.466 0 006.596 6.596 6.775 6.775 0 002.334.614 3.58 3.58 0 002.764-1.4 4.314 4.314 0 00.27-1.24.54.54 0 00-.024-.197z"
});

function SvgSpMenuPager(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "spMenuPager.d2f78.svg";
export { SvgSpMenuPager as ReactComponent };